import React from 'react'
import _ from 'lodash'

import ReportTable from '../report_table'
import MemberTableOrg from './report_member_table'
import * as Helper from '../../../../helpers/helper'
import { localeNumberFormatter, truncateEnd } from '../helpers'

// port of cowebapp analytics/components/prospect/report_org_table.js
const ReportTableOrg = (props) => {

  const expandRowComp = (row) => {
    return (<MemberTableOrg
      memberData={row.stats}
      breakdown={props.userReportData.breakdown}
      id={row.user_id}
    />
    )
  }

  const expandRow = {
    className: 'expanding-row',
    parentClassName: 'parent-expand-row',
    renderer: row => expandRowComp(row)
  }

  const noDataIndication = () => {
    return (
      <div
        className="list-container text-center bg-white"
        style={{ padding: '10px' }}
      >
        <p className="m-0">
          No Activity Found
        </p>
      </div>
    )
  }

  const emailFormatter = (cell, row) => {
    return (
      <div
        className="d-flex org-email-column"
        title={row.email}
      >
        <div className='word-break-all'>
          {truncateEnd(Helper.capitalizeFirstLetter(_.isEmpty(row.name) ? '-' : row.name), 18)}
          <small>
            <div className="d-flex">
              <span className='word-break-all'>
                {truncateEnd(row.email, 24)}
              </span>
            </div>
          </small>
        </div>
      </div>
    )
  }

  const getTableData = () => {
    let tableData = []
    props.tableData.forEach((data) => {
      let total_billable_lead = 0
      let total_credits_charged = 0
      let total_email_credits = 0
      let total_phone_credits = 0
      data.stats.forEach((stat) => {
        total_billable_lead = total_billable_lead + stat.total_billable_lead
        total_email_credits = total_email_credits + stat.total_email_credits
        total_phone_credits = total_phone_credits + stat.total_phone_credits
        total_credits_charged = total_credits_charged + stat.total_credits_charged
      })

      tableData.push({
        email: data.email,
        stats: data.stats,
        user_id: data.user_id,
        name: data.name,
        total_billable_lead: total_billable_lead,
        total_email_credits: total_email_credits,
        total_phone_credits: total_phone_credits,
        total_credits_charged: total_credits_charged
      })

    })
    return tableData
  }

  const data = getTableData()
  const rowClasses = 'custom-row-class'
  const formatNumber = localeNumberFormatter('-')
  const colWidth = { width: '20%' }

  const columns = [
    {
      dataField: 'email',
      text: 'Member',
      formatter: emailFormatter,
      headerStyle: colWidth,
      style: colWidth,
      sort: true
    },
    {
      dataField: 'total_billable_lead',
      text: 'Total Prospects',
      headerStyle: colWidth,
      style: colWidth,
      formatter: formatNumber,
      align: 'right',
      sort: true
    },
    {
      dataField: 'total_email_credits',
      text: 'Email Enrichment Credits',
      headerStyle: colWidth,
      style: colWidth,
      formatter: formatNumber,
      align: 'right',
      sort: true,
      headerTitle: () => 'Email Enrichment Credits'
    },
    {
      dataField: 'total_phone_credits',
      text: 'Phone Enrichment Credits',
      headerStyle: colWidth,
      style: colWidth,
      formatter: formatNumber,
      align: 'right',
      sort: true
    },
    {
      dataField: 'total_credits_charged',
      text: 'Billable Credits',
      headerStyle: colWidth,
      style: colWidth,
      formatter: formatNumber,
      align: 'right',
      sort: true
    }
  ]

  const defaultSorted = [{
    dataField: 'total_billable_lead',
    order: 'desc'
  }]

  return (
    <div className="report-table">
      <ReportTable
        wrapperClasses="table-report-org table-responsive"
        expandRow={expandRow}
        noDataIndication={noDataIndication}
        keyField="user_id"
        data={data}
        columns={columns}
        rowClasses={rowClasses}
        defaultSorted={defaultSorted}
      />
    </div>
  )
}

export default ReportTableOrg
